import { gql } from "graphql-tag";

export const PROPERTY_PAGE_TITLE = gql`
  query PropertyPageTitle($id: ID!) {
    property(id: $id) {
      id
      name
    }
  }
`;
